import Vue from 'vue'
import Icon from 'vue-awesome/components/Icon.vue'

import App from './App.vue'
import router from './router/index'
import './element/element'
import SvgIcon from './views/base/SvgIcon'
import Plugin from './plugin'
import 'babel-polyfill'
import './icons'

Vue.component('icon', Icon)
Vue.component(SvgIcon.name, SvgIcon)
Vue.use(Plugin)

Vue.config.productionTip = false
new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

if (process.env.VUE_APP_ENV === 'PUBLISH') require('autotrack/autotrack')
